import { Component, OnInit, Input } from '@angular/core';
import {UserService} from '../../user.service';
import {User} from '../../models/users.model';


//import { ngSanitize } from 'angular-sanitize';

//./angular-sanitize

//import { ActivatedRoute } from '@angular/router';

import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-labs',
  templateUrl: './labs.component.html'
})
export class LabsComponent implements OnInit {

  // @Input() page: number;

  page = -1;

  user:User;





  titleOptions = [
	  'Intro',
	  'Pre-requisites',
	  'Create a Admin IAM User with full admin permissions. Login as that user for the rest of the lab.',
	  'Create security group that allows SSH and HTTPS access',
	  'Create a EC2 Instance using the Amazon AMI and install Apache with a hello world website. Access the site from the internet. Log into the the ec2 instance from your terminal using the generated ec2 SSH keys. Repeat this lab but create a bootstrap script to install apache, create the index.html file, and start apache without having to log into the box.'
  ]



  aboutThisLabDescription = [


	  'Here is a space for a written summary of the course, as well as a space for a <a href="#">video-link</a>.',

	  '<ol><li>Create a free <a href="https://portal.aws.amazon.com/billing/signup#/start">AWS account</a></li><li>Review acloud.guru&#39;s System Arcitecht Associate <a href="https://acloud.guru/learn/aws-certified-solutions-architect-associate">course</a></li></ol>',

	  'Here is placeholder content for this lab: Create a Admin IAM User with full admin permissions. Login as that user for the rest of the lab.',

	  'And here is placeholder content for this lab: Create security group that allows SSH and HTTPS access',

	  'And last but not least, here is placeholder content for this lab: Create a EC2 Instance using the Amazon AMI and install Apache with a hello world website. Access the site from the internet. Log into the the ec2 instance from your terminal using the generated ec2 SSH keys. Repeat this lab but create a bootstrap script to install apache, create the index.html file, and start apache without having to log into the box.'

  ]


  //aboutThisLabDescription = $sce.trustAsHtml(aboutThisLabDescriptionPreHTML);

  toggle0 = false;
  toggle1 = false;
  toggle2 = false;
  toggle3 = false;
  toggle4 = false;
  toggle5 = false;
  toggle6 = false;
  toggle7 = false;
  toggle8 = false;
  toggle9 = false;
  toggle10 = false;
  toggle11 = false;
  toggle12= false;
  toggle13 = false;
  toggle14 = false;
  toggle15 = false;
  toggle16 = false;
  toggle17 = false;

  constructor(private userService: UserService, private router: Router, private activatedRoute: ActivatedRoute ) { }

  ngOnInit() {

    this.setPage( Number(this.activatedRoute.snapshot.paramMap.get("labNumber")));

    /*  */
    this.activatedRoute.paramMap.subscribe( params => {
      this.setPage( Number(params.get("labNumber") ) );
    });
  }

  nextLab() {
    this.page += 1;
  }

  previousLab() {
    if (this.page >= 0) {
      this.page -= 1;
    }
  }

  setPage(num) {
    this.page = num;
  }
	gotoCoursesPage() {

		this.router.navigate(['/courses']);
	}

	next(){
    this.router.navigate([`/course/p2/awsop/${this.page}`]);
  }

  toggle(num) {
    console.log('TOGGLE"')
    console.log(num);
    switch(parseInt(num)) {
      case 0:
        console.log(num, this.toggle0);
        this.toggle0 = !this.toggle0;
        break;
      case 1:
        this.toggle1 = !this.toggle1;
        break;
      case 2:
        this.toggle2 = !this.toggle2;
        break;
      case 3:
        this.toggle3 = !this.toggle3;
        break;
      case 4:
        this.toggle4 = !this.toggle4;
        break;
      case 5:
        this.toggle5 = !this.toggle5;
        break;
      case 6:
        this.toggle6 = !this.toggle6;
        break;
      case 7:
        this.toggle7 = !this.toggle7;
        break;
      case 8:
        this.toggle8 = !this.toggle8;
        break;
      case 9:
        this.toggle9 = !this.toggle9;
        break;
      case 10:
        this.toggle10 = !this.toggle10;
        break;
      case 11:
        this.toggle11 = !this.toggle11;
        break;
      case 12:
        this.toggle12 = !this.toggle12;
        break;
      case 13:
        this.toggle13 = !this.toggle13;
        break;
      case 14:
        this.toggle14 = !this.toggle14;
        break;
      case 15:
        this.toggle15 = !this.toggle15;
        break;
      case 16:
        this.toggle16 = !this.toggle16;
        break;
      case 17:
        this.toggle17 = !this.toggle17;
        break;
    }
  }






}



// WEBPACK FOOTER //
// ./src/app/course/labs/labs.component.ts